import { render, staticRenderFns } from "./ButtomBar.vue?vue&type=template&id=067c5bdb"
import script from "./ButtomBar.vue?vue&type=script&lang=js"
export * from "./ButtomBar.vue?vue&type=script&lang=js"
import style0 from "./ButtomBar.vue?vue&type=style&index=0&id=067c5bdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports